/**
 * JourneyChain — inline status pills with arrows for the Timeline header.
 *
 * Renders `Pending → Attention → Done → Exported`. Each status uses
 * the redesign status palette so the user sees the photo's lifecycle
 * at a glance before scrolling the event detail.
 *
 * Props:
 *   journey: string[] of status labels in order
 */

import StatusPill from './StatusPill';
import styles from './JourneyChain.module.css';

export default function JourneyChain({ journey = [] }) {
  if (!Array.isArray(journey) || journey.length === 0) return null;
  return (
    <span className={styles.chain} role="list" aria-label="Status journey">
      {journey.map((status, i) => (
        <span key={`${status}-${i}`} className={styles.step} role="listitem">
          <StatusPill status={status} />
          {i < journey.length - 1 && (
            <span className={styles.arrow} aria-hidden="true">→</span>
          )}
        </span>
      ))}
    </span>
  );
}
